export const deleteSpacesFromImageLink = (linkToCdn: string) => {
  return linkToCdn.replace(/ /g, '%20');
};
